export default __webpack_public_path__ + "static/media/05_Jahzzar_-_Comedie.c3ade14a.mp3";